export default "__VITE_ASSET__J5crgL28__"